import { createFileRoute } from '@tanstack/react-router';
import { ViewSubmissionScreen } from '@/quiz-submission/ViewSubmissionScreen';

/**
 * The group mount of the view screen, built once in `@/quiz-submission/` and
 * shared with the member mount; see `ViewSubmissionScreen`.
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId',
)({
  component: GroupQuizSubmissionViewScreen,
});

function GroupQuizSubmissionViewScreen() {
  const { submissionId } = Route.useParams();
  return (
    <ViewSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
